import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import DocFullScreenExample from '../UI/DocFullScreenExample';
import CategoryListExample from '../examples/CategoryList';
import CategoryListBoxesExample from '../examples/CategoryListBoxes';
import CategoryListWithActiveCategoryExample from '../examples/CategoryListWithActiveCategory';
import CategoryListWithoutIconsExample from '../examples/CategoryListWithoutIcons';
const CategoryListExampleSource = require('!!raw-loader!../examples/CategoryList');
const CategoryListBoxesExampleSource = require('!!raw-loader!../examples/CategoryListBoxes');
const CategoryListWithActiveCategoryExampleSource = require('!!raw-loader!../examples/CategoryListWithActiveCategory');
const CategoryListWithoutIconsExampleSource = require('!!raw-loader!../examples/CategoryListWithoutIcons');
export default class CategoryListPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="CategoryList"/>

                <h3>CategoryList</h3>
                <div className="docs-example bg-content">
                    <CategoryListExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CategoryListExampleSource}</PrismCode>
                </pre>
                <div>
                    <h4>CategoryList Properties</h4>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`CategoryList.propTypes = {
    items: Array<CategoryItemType>,
    showBoxes: boolean,
    showIcons: boolean,
}

CategoryList.defaultProps = {
   showBoxes: false,
   showIcons: true,
}`}
                        </PrismCode>
                    </pre>
                </div>

                <h3>CategoryList Boxes</h3>
                <DocFullScreenExample container className="bg-content">
                    <CategoryListBoxesExample />
                </DocFullScreenExample>
                <pre>
                    <PrismCode className="language-jsx">{CategoryListBoxesExampleSource}</PrismCode>
                </pre>
                <div>
                    <h4>CategoryList Properties</h4>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`CategoryList.propTypes = {
    items: Array<CategoryItemType>,
    showBoxes: boolean,
    showIcons: boolean,
}

CategoryList.defaultProps = {
   showBoxes: false,
   showIcons: true,
}`}
                        </PrismCode>
                    </pre>
                </div>

                <h3>CategoryList with active category</h3>
                <div className="docs-example bg-content">
                    <CategoryListWithActiveCategoryExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CategoryListWithActiveCategoryExampleSource}</PrismCode>
                </pre>
                <div>
                    <h4>CategoryList Properties</h4>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`CategoryList.propTypes = {
    items: Array<CategoryItemType>,
    showBoxes: boolean,
    showIcons: boolean,
}

CategoryList.defaultProps = {
   showBoxes: false,
   showIcons: true
}`}
                        </PrismCode>
                    </pre>
                </div>

                <h3>CategoryList without icons</h3>
                <div className="docs-example bg-content">
                    <CategoryListWithoutIconsExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{CategoryListWithoutIconsExampleSource}</PrismCode>
                </pre>
                <div>
                    <h4>CategoryList Properties</h4>
                    <pre>
                        <PrismCode className="language-jsx">
                            {`CategoryList.propTypes = {
    items: Array<CategoryItemType>,
    showBoxes: boolean,
    showIcons: boolean,
}

CategoryList.defaultProps = {
   showBoxes: false,
   showIcons: true,
}`}
                        </PrismCode>
                    </pre>
                </div>
            </div>);
    }
}
